<template>
  <div v-if="show">
    <div class="ui active">
      <div class="ui inverted loader"></div>
    </div>
    <h4>
      Found <span style="color: blue">{{ count }}</span> Products by searching
      <span v-if="category" style="color: brown"
        >category : {{ category.name }}</span
      >
      <span v-if="keyword" style="color: green"> keyword :{{ keyword }}</span>
    </h4>
    <table class="ui celled table productslist">
      <thead>
        <tr>
          <th>Id</th>
          <th>{{ $t('Image') }}</th>
          <th>{{ $t('Name') }}</th>
          <th>{{ $t('Reference') }}</th>
          <th>{{ $t('Category') }}</th>
          <th>{{ $t('Combinations') }}</th>
          <th>{{ $t('Price') }}</th>
          <th>{{ $t('Ops') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="searching">
          <td colspan="8">
            <div class="ui inverted segment">
              <p></p>
              <div class="ui active">
                <div class="ui inverted loader"></div>
              </div>
            </div>
          </td>
        </tr>
        <tr
          v-for="product in products"
          :key="product.id_product"
          :id="
            'customer_' + currentCustomer.id + '_product_' + product.id_product
          "
          class="product"
        >
          <td>
            {{ product.id_product }}
          </td>
          <td>
            <img
              v-if="product.product_image"
              :src="product.product_image"
            />
          </td>
          <td>
            <a
              :href="product.front_office_link"
              >{{ product.name }}</a
            >
          </td>
          <td>
            <span v-if="product.reference" style="color: black">{{
              product.reference
            }}</span>
            <span v-else style="color: orange">N/A </span>
          </td>
          <td>
            {{ product.category }}
          </td>
          <td>
            <select
              v-if="Object.keys(product.combinations).length > 0"
              v-model="id_combination[product.id_product]"
              class="ui fluid dropdown selection"
              style="height: 40px"
            >
              <option
                v-for="combination in product.combinations"
                :key="combination.id_product_attribute"
                :value="combination.id_product_attribute"
                :selected="combination.default_on == '1' ? 'selected' : ''"
              >
                {{ combination.attributes }} - {{ combination.price_tax_incl }} €
              </option>
            </select>
            <span v-else style="color: orange">N/A</span>
          </td>

          <td>{{ product.formatted_price }}</td>
          <td class="right aligned">
            <button
              title="Add this product"
              class="ui button icon blue"
              @click="addToCart(product)"
            >
              <i class="add icon"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <pagination
      v-if="count"
      :key="customerId"
      :count="parseInt(count, 10)"
      :current-page="currentPage"
      @selectSize="handleSizeSelect"
      @jumpToPage="handlePageJump"
    ></pagination>
  </div>
</template>

<style scoped>
.productslist .product img {
  height: 50px;
  width: auto;
}

.closebutton {
  margin-left: auto !important;
}
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FoundProducts',
  props: {
    customerId: {
      type: Number,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    searching: {
      type: Boolean,
      default: false
    },
    category: {
      type: Object,
      default: null
    },
    keyword: {
      type: String,
      default: null
    },
    foundProducts: {
      type: Object,
      default: null
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,
      id_combination: {}
    }
  },
  computed: {
    ...mapGetters({
      currentCustomer: 'getCurrentCustomer',
      cartAmount: 'getCartAmount',
      shopAddress: 'getShopAddress',
      groups: 'getGroups',
      user: 'getUser'
    }),
    count() {
      return this.foundProducts ? this.foundProducts.count : 0
    },
    products() {
      return this.foundProducts ? this.foundProducts.products : []
    }
  },
  watch: {
    products(newVal) {
      if (!newVal) {
        return
      }
      newVal.forEach((product) => {
        let defaultAttribute = null
        Object.keys(product.combinations).forEach((combinationId) => {
          if (product.combinations[combinationId].default_on === '1') {
            defaultAttribute = combinationId
          }
        })
        this.$set(this.id_combination, product.id_product, defaultAttribute)
      })
    }
  },
  methods: {
    getInputType(customizationFieldType) {
      if (customizationFieldType === '0') return 'file'
      if (customizationFieldType === '1') return 'text'
      return null
    },
    getCustomizationFieldName(productId, customizationFieldId) {
      return `customization_${productId}_${customizationFieldId}`
    },

    getCustomizationFieldId(productId, customizationFieldId) {
      return `customization_${productId}_${customizationFieldId}`
    },
    addToCart(product) {
      const productToAdd = { ...product }
      productToAdd.id_combination = this.id_combination[product.id_product]
      productToAdd.attribute_list = product.combinations[productToAdd.id_combination]
        ? product.combinations[productToAdd.id_combination].attribute_list
        : []
      productToAdd.source = 'prestashop'

      if(!productToAdd.price && !productToAdd.id_combination)
        productToAdd.price = productToAdd.price_tax_incl
      this.$store.dispatch('addFromExistingProduct', productToAdd);
    },
    handleSizeSelect(size) {
      this.$emit('changePageSize', size)
    },
    handlePageJump(page) {
      this.$emit('changePage', page)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FoundProducts.vue?5dac9f48